import React,{useState}  from 'react';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import{
  Button,TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  colors
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  btnAceptar:{
    color:colors.green[500],
  },
  btnCancelar:{
    color:colors.red[500],
  }
}));
const  ModalFormulario=(props)=> {
  const {  open,titulo,ContenidoMensaje,OnCancelar,OnCerrar,width,skroll,bloqueo,aceptar,children, cerrarTarea, onCerrarTarea,...rest} = props;
  const classes=useStyles(); 
  return (
      <Dialog 
        open={open} 
        onClose={OnCerrar} 
        fullWidth maxWidth={width}
        aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">
          {titulo}
        </DialogTitle>
        <form > {/*** onSubmit={aceptar} */}
            <DialogContent>
            <DialogContentText>
                {ContenidoMensaje}
            </DialogContentText>
            <div className='MuiDialogContentText-root'>
            {children}
            </div>
            </DialogContent>
            <DialogActions>
              <Button onClick={OnCancelar} className='btnError'>
                  Cancelar
              </Button>
              <Button type="submit" onClick={aceptar} disabled={bloqueo} className={classes.btnAceptar}>
                Guardar
              </Button>
              {cerrarTarea && 
                <Button type="submit" onClick={onCerrarTarea} disabled={bloqueo} className={classes.btnAceptar}>
                  Guardar y cerrar Tarea
                </Button>
              }
            </DialogActions>
        </form>
      </Dialog>
  );
}
ModalFormulario.propTypes={
  open:PropTypes.bool.isRequired,
  titulo:PropTypes.string.isRequired
  ,ContenidoMensaje:PropTypes.string
  ,OnCancelar:PropTypes.func.isRequired,
  children:PropTypes.node,
}
ModalFormulario.defaultProps = {
  width:"sm",
  bloqueo:false,
  skroll:'paper',
};
export default ModalFormulario;